import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight, Download } from "lucide-react";
import { profile } from "../../data/portfolio";

export const Contact = () => {
  return (
    <section
      id="contact"
      data-testid="section-contact"
      className="relative w-full py-28 md:py-40 border-t border-neutral-900"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="flex items-center gap-3 mb-10"
        >
          <span className="text-mono-label">05</span>
          <span className="text-mono-label">Contact</span>
        </motion.div>

        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
          className="font-serif text-5xl sm:text-6xl md:text-7xl lg:text-8xl tracking-tighter leading-[0.95] text-neutral-100 max-w-5xl"
        >
          Have a system worth
          <br />
          <span className="italic text-neutral-400">simplifying?</span>
        </motion.h2>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: 0.15 }}
          className="mt-16 md:mt-24 grid grid-cols-1 md:grid-cols-12 gap-10"
        >
          <div className="md:col-span-7 space-y-5">
            <div className="text-mono-label">Direct line</div>
            <a
              href={`mailto:${profile.email}`}
              data-testid="contact-email-link"
              className="inline-block font-serif text-3xl sm:text-4xl md:text-5xl text-neutral-100 underline-anim"
            >
              {profile.email}
            </a>
            <p className="text-neutral-500 max-w-xl leading-relaxed pt-2">
              The fastest way to start. Expect a reply within 48 hours on weekdays.
            </p>

            {/* Resume download */}
            {profile.resumeUrl && (
              <a
                href={profile.resumeUrl}
                download
                data-testid="contact-resume-download"
                className="inline-flex items-center gap-3 border border-neutral-700 hover:border-neutral-100 hover:bg-neutral-100 hover:text-neutral-950 px-5 py-3 font-mono text-xs uppercase tracking-[0.2em] text-neutral-300 transition-all duration-300 group"
              >
                <Download size={13} className="group-hover:translate-y-0.5 transition-transform duration-300" />
                Download Resume
              </a>
            )}
          </div>

          <div className="md:col-span-5 space-y-3">
            <div className="text-mono-label mb-3">Elsewhere</div>
            <ul className="border-t border-neutral-900">
              {profile.socials.map((s) => (
                <li key={s.label} className="border-b border-neutral-900">
                  <a
                    href={s.href}
                    target="_blank"
                    rel="noreferrer"
                    data-testid={`contact-social-${s.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                    className="group flex items-center justify-between py-5 hover:pl-2 transition-[padding] duration-300"
                  >
                    <span className="font-serif text-xl md:text-2xl text-neutral-100">
                      {s.label}
                    </span>
                    <ArrowUpRight
                      size={20}
                      className="text-neutral-500 group-hover:text-neutral-100 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all"
                    />
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Contact;
